var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { bindable } from 'aurelia-templating';
import { transient } from "aurelia-dependency-injection";
import { observable } from 'aurelia-framework';
import * as Enumerable from 'linq';
var Slider = /** @class */ (function () {
    function Slider(element) {
        var _this = this;
        this.element = element;
        this.steps = [];
        this.label = "";
        this.min = 0;
        this.step = 1;
        this.max = 100;
        this.isGroupButtons = false;
        this.disabled = false;
        this.onKeyDown = function ($event) {
            if (!_this.sliderContainer || !_this.sliderContainer.contains($event.target) || _this.disabled) {
                return;
            }
            var max = Number(_this.max);
            var min = Number(_this.min);
            if ($event.keyCode == '37') {
                if (_this.value == min) {
                    return;
                }
                _this.value -= 1;
            }
            else if ($event.keyCode == '39') {
                if (_this.value == max) {
                    return;
                }
                _this.value += 1;
            }
        };
        this.onMouseDown = function ($event) {
            if (!_this.sliderContainer || !_this.sliderContainer.contains($event.target) || _this.disabled) {
                return;
            }
            var pageX = $event.touches ? $event.touches[0].pageX : $event.pageX;
            document.addEventListener('mousemove', _this.onMouseMove, false);
            document.addEventListener('touchmove', _this.onMouseMove, false);
            document.addEventListener('mouseup', _this.onMouseUp, false);
            document.addEventListener('touchend', _this.onMouseUp, false);
            _this._offset = pageX - _this.sliderHandle.getBoundingClientRect().left;
        };
        this.onMouseMove = function ($event) {
            var pageX = $event.touches ? $event.touches[0].pageX : $event.pageX;
            var maxLeft = _this.sliderContainer.offsetWidth - _this.sliderHandle.offsetWidth;
            var left = (pageX - _this.sliderContainer.getBoundingClientRect().left - _this._offset);
            if (left <= 0) {
                left = 0;
            }
            else if (left > maxLeft) {
                left = maxLeft;
            }
            var step = 1 / Number(_this.step);
            var max = Number(_this.max);
            var min = Number(_this.min);
            var value = (max - min) * (left / maxLeft) + min;
            _this.value = (Math.round(value * step) / step);
        };
        this.onMouseUp = function ($event) {
            _this._offset = null;
            try {
                document.removeEventListener('mousemove', _this.onMouseMove, false);
                document.removeEventListener('mouseup', _this.onMouseUp, false);
                document.removeEventListener('touchmove', _this.onMouseMove, false);
                document.removeEventListener('touchend', _this.onMouseUp, false);
            }
            catch (ex) {
                console.log(ex);
            }
        };
        this.onSliderContainerClick = function ($event) {
            if (_this.disabled)
                return;
            var pageX = $event.touches ? $event.touches[0].pageX : $event.pageX;
            var maxLeft = _this.sliderContainer.offsetWidth - _this.sliderHandle.offsetWidth;
            var left = (pageX - _this.sliderContainer.getBoundingClientRect().left - (_this.sliderHandle.offsetWidth / 2));
            if (left <= 0) {
                left = 0;
            }
            else if (left > maxLeft) {
                left = maxLeft;
            }
            var step = 1 / Number(_this.step);
            var max = Number(_this.max);
            var min = Number(_this.min);
            var value = (max - min) * (left / maxLeft) + min;
            _this.value = (Math.round(value * step) / step);
        };
    }
    Slider.prototype.attached = function () {
        var _this = this;
        if (this.sliderContainer && this.sliderHandle) {
            setTimeout(function () {
                _this.setValue();
            }, 120);
        }
    };
    Slider.prototype.isGroupButtonsChanged = function () {
        if (this.isGroupButtons) {
            this.steps = this.getSteps();
        }
    };
    Slider.prototype.getSteps = function () {
        if (this.step) {
            return Enumerable.range(this.min, (1 + this.max - this.min) / this.step, this.step).toArray();
        }
        return [];
    };
    Slider.prototype.select = function (num) {
        if (!this.disabled) {
            this.value = num;
        }
    };
    Slider.prototype.valueChanged = function () {
        this.setValue();
    };
    Slider.prototype.maxChanged = function () {
        if (this.isGroupButtons) {
            this.steps = this.getSteps();
        }
        if (this.value > this.max) {
            this.value = this.max;
        }
        else {
            this.setValue();
        }
    };
    Slider.prototype.minChanged = function () {
        if (this.isGroupButtons) {
            this.steps = this.getSteps();
        }
        if (this.value < this.min) {
            this.value = this.min;
        }
        else {
            this.setValue();
        }
    };
    Slider.prototype.sliderHandleChanged = function (newValue, oldValue) {
        if (newValue) {
            newValue.addEventListener('mousedown', this.onMouseDown, false);
            newValue.addEventListener('touchstart', this.onMouseDown, false);
            newValue.addEventListener('keydown', this.onKeyDown, false);
            this.setValue();
        }
        else if (oldValue) {
            oldValue.removeEventListener('mousedown', this.onMouseDown, false);
            oldValue.removeEventListener('touchstart', this.onMouseDown, false);
            oldValue.removeEventListener('keydown', this.onKeyDown, false);
        }
    };
    Slider.prototype.setValue = function () {
        if (!this.sliderContainer || !this.sliderHandle) {
            return;
        }
        var percentage = (this.value - this.min) / (this.max - this.min);
        var left = (this.sliderContainer.offsetWidth - this.sliderHandle.offsetWidth) * percentage;
        if (left + this.sliderHandle.offsetWidth <= this.sliderContainer.offsetWidth && left >= 0) {
            this.sliderHandleLeft = left + 'px';
        }
        else if (left <= 0) {
            this.sliderHandleLeft = '0px';
        }
        else if (left + this.sliderHandle.offsetWidth > this.sliderContainer.offsetWidth) {
            this.sliderHandleLeft = (this.sliderContainer.offsetWidth - this.sliderHandle.offsetWidth) + 'px';
        }
        var paramsEvent = { detail: { value: this.value }, bubbles: true };
        var changeValueEvent = new CustomEvent("value-changed", paramsEvent);
        this.element.dispatchEvent(changeValueEvent);
    };
    __decorate([
        observable(),
        __metadata("design:type", HTMLElement)
    ], Slider.prototype, "sliderContainer", void 0);
    __decorate([
        observable(),
        __metadata("design:type", HTMLElement)
    ], Slider.prototype, "sliderHandle", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], Slider.prototype, "label", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], Slider.prototype, "min", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], Slider.prototype, "step", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], Slider.prototype, "max", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], Slider.prototype, "value", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], Slider.prototype, "tabindex", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], Slider.prototype, "isGroupButtons", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], Slider.prototype, "disabled", void 0);
    Slider = __decorate([
        transient(),
        __metadata("design:paramtypes", [Element])
    ], Slider);
    return Slider;
}());
export { Slider };
